/** Human-readable name for the single bridge-backed MCP server passed to ACP agents. */
export const BRIDGE_MCP_SERVER_NAME = 'buildautomaton-bridge';
